import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClientFormComponent } from './client-form/client-form.component';
import { SuccessPageComponent } from './success-page/success-page.component';
import { AttendanceFormComponent } from './attendance-form/attendance-form.component';
import { AttendanceFormCanDeactivateGuard } from './attendance-form/attendance-form-leave.gurad';
import { QuestionnaireFormComponent } from './questionnaire-form/questionnaire-form.component';
import { QuestionnaireFormCanDeactivateGuard } from './questionnaire-form/questionnaire-form-leave.gurad';
import { RedirectPageComponent } from './redirect-page/redirect-page.component';

const routes: Routes = [
  {
    path: 'R/:key',
    component: RedirectPageComponent,
  },
  {
    path: 'r/:key',
    component: RedirectPageComponent,
  },
  {
    path: 'ClientForm',
    component: ClientFormComponent,
  },
  {
    path: 'clientform',
    component: ClientFormComponent,
  },
  {
    path: 'AttendanceForm',
    component: AttendanceFormComponent,
    canDeactivate: [AttendanceFormCanDeactivateGuard],
  },
  {
    path: 'attendanceform',
    component: AttendanceFormComponent,
    canDeactivate: [AttendanceFormCanDeactivateGuard],
  },
  {
    path: 'QuestionnaireForm',
    component: QuestionnaireFormComponent,
    canDeactivate: [QuestionnaireFormCanDeactivateGuard],
  },
  {
    path: 'questionnaireform',
    component: QuestionnaireFormComponent,
    canDeactivate: [QuestionnaireFormCanDeactivateGuard],
  },
  {
    path: 'success',
    component: SuccessPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
